
import * as React from 'react';
import { useSecurity } from '../useSecurity';
import SecuredElement from './securedElement';

type ISecuredZone = {
  roles?: string[]
}

const SecuredZone: React.FC<ISecuredZone> = (props) => {
  const { unauthenticatedElement, unauthorizedElement, authenticated, isInRole, defaultRoles, signIn} = useSecurity();

  const restrictedRoles = props.roles || [];
  const validRoles = restrictedRoles.length > 0 ? restrictedRoles : defaultRoles;  
  const isAuthorized = isInRole(validRoles)

  React.useEffect(() => {
    if (!authenticated) signIn();
  }, []);

  return (<SecuredElement
    unauthenticatedElement={unauthenticatedElement}
    unauthorizedElement={unauthorizedElement}
    isAuthenticated={authenticated}
    isAuthorized={isAuthorized}
  >
    {props.children}
  </SecuredElement>);
} 

export default SecuredZone;